import React from 'react';
import {
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const ImportExportMenuItemLabel = ({
  primaryIcon = null,
  label,
  secondaryLabel,
  secondaryIcon = null
}) => {
  const hasPrimaryIcon = primaryIcon ? (
    <ListItemIcon>{primaryIcon}</ListItemIcon>
  ) : null;

  const hasSecondaryIcon = secondaryIcon ? (
    <ListItemSecondaryAction>{secondaryIcon}</ListItemSecondaryAction>
  ) : null;

  const hasSecondaryLabel = secondaryLabel ? (
    <FormattedMessage id={`${secondaryLabel}`} />
  ) : null;

  return (
    <>
      {hasPrimaryIcon}
      <ListItemText
        primary={<FormattedMessage id={`${label}`} />}
        secondary={hasSecondaryLabel}
      />
      {hasSecondaryIcon}
    </>
  );
};

ImportExportMenuItemLabel.propTypes = {
  primaryIcon: PropTypes.node,
  label: PropTypes.node.isRequired,
  secondaryLabel: PropTypes.node,
  secondaryIcon: PropTypes.node
};

export default ImportExportMenuItemLabel;
